import { useState,useContext } from "react";
import userContext from "./Context";
function Withdraw(){

 const [input, setInput] = useState("");
 const ctx = useContext(userContext);

  function handleWithdraw(){
   const newAmount=ctx.amount - Number(input)
   ctx.setAmount(newAmount)
    console.log(newAmount);
  }

  return(
    <>
    <div className="d-flex justify-content-center align-items-center bg-secondary vh-100">
            <div className="bg-white p-3 rounded w-25">
      <center><h3>WITHDRAW</h3></center><br></br>

      <label><h4>Amount</h4></label><br />

      <input
        type="number"
        onChange={(e) => setInput(e.target.value)}
      />&nbsp;&nbsp;

      <button onClick={handleWithdraw} className="btn btn-success rounded-10">Withdraw</button>

      <br /><br />

      <h4>Total</h4>
      <div>{ctx.amount}</div>
      </div>
      </div>
    </>
  );
}

export default Withdraw;
